import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "../../api/apiHelper";

const Billing = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [quantity, setQuantity] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const planData = {
      planId: params.get("planId"),
      planName: params.get("planName"),
      pricePerUser: parseFloat(params.get("pricePerUser")) || 0,
      billingCycle: params.get("billingCycle") || "monthly",
    };
    setSelectedPlan(planData);
    fetchTeamMembers();
    
    // Clear the selected plan from sessionStorage to prevent edge cases
    sessionStorage.removeItem("selectedPlan");
  }, [location.search]);

  const calculateTotalBill = () => {
    if (!selectedPlan?.pricePerUser) return 0;
    return quantity * selectedPlan.pricePerUser;
  };

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      const response = await apiRequest("get", "/invite/get-team-member");
      let membersData = [];

      if (response?.data?.result) membersData = response.data.result;
      else if (Array.isArray(response?.data)) membersData = response.data;
      else if (Array.isArray(response)) membersData = response;
      else if (response?.result) membersData = response.result;
      else if (response?.data?.data) membersData = response.data.data;

      setTeamMembers(membersData);
    } catch (err) {
      console.error("Error fetching team members:", err);
      setError("Error loading team members");
      setTeamMembers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleQuantityChange = (type) => {
    setQuantity((prev) => {
      if (type === "increment")
        return Math.min(prev + 1, teamMembers.length || prev + 1);
      if (type === "decrement") return Math.max(prev - 1, 1);
      return prev;
    });
  };

  const handleProceedToCheckout = () => {
    console.log("Proceeding to checkout with quantity:", quantity);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc" }}>
      {/* Professional Navbar */}
      <div style={{
        backgroundColor: "white",
        borderBottom: "1px solid #e2e8f0",
        padding: "16px 0",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <button
              onClick={handleCancel}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 16px",
                backgroundColor: "#f1f5f9",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#475569",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#e2e8f0";
                e.target.style.borderColor = "#94a3b8";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#f1f5f9";
                e.target.style.borderColor = "#cbd5e1";
              }}
            >
              ← Back to Pricing & Plans
            </button>
            <div style={{
              height: "24px",
              width: "1px",
              backgroundColor: "#e2e8f0"
            }}></div>
            <h1 style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1e293b",
              margin: "0"
            }}>
              Complete Your Purchase
            </h1>
          </div>
          <div style={{
            padding: "8px 16px",
            backgroundColor: "#dbeafe",
            borderRadius: "20px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#1e40af"
          }}>
            Step 2 of 3
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "24px",
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          color: "#111827",
        }}
      >
        {/* Main Layout */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.2fr 1fr",
            gap: "24px",
            alignItems: "start"
          }}
        >
          {/* Left Card */}
          <div
            style={{
              backgroundColor: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
            }}
          >
            {selectedPlan ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    flexWrap: "wrap",
                    gap: "16px",
                  }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "700",
                        marginBottom: "5px",
                      }}
                    >
                      {decodeURIComponent(selectedPlan.planName)}
                    </h2>
                    <p style={{ fontSize: "0.9rem", color: "#6b7280" }}>
                      ${selectedPlan.pricePerUser} / seat (
                      {selectedPlan.billingCycle})
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #d1d5db",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <button
                      onClick={() => handleQuantityChange("decrement")}
                      style={{
                        width: "42px",
                        height: "42px",
                        fontSize: "1.3rem",
                        fontWeight: "600",
                        backgroundColor: "#f9fafb",
                        border: "none",
                        cursor: "pointer",
                        transition: "0.2s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.backgroundColor = "#f3f4f6")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                    >
                      −
                    </button>
                    <div
                      style={{
                        width: "70px",
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "1rem",
                        backgroundColor: "#fff",
                        borderLeft: "1px solid #e5e7eb",
                        borderRight: "1px solid #e5e7eb",
                      }}
                    >
                      {quantity}
                    </div>
                    <button
                      onClick={() => handleQuantityChange("increment")}
                      style={{
                        width: "42px",
                        height: "42px",
                        fontSize: "1.3rem",
                        fontWeight: "600",
                        backgroundColor: "#f9fafb",
                        border: "none",
                        cursor: "pointer",
                        transition: "0.2s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.backgroundColor = "#f3f4f6")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.backgroundColor = "#f9fafb")
                      }
                    >
                      +
                    </button>
                  </div>
                </div>

                {teamMembers.length > 0 && (
                  <div
                    style={{
                      marginTop: "16px",
                      padding: "16px",
                      backgroundColor: "#f9fafb",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      Available Team Members ({teamMembers.length})
                    </h3>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(200px, 1fr))",
                        gap: "10px",
                        maxHeight: "300px",
                        overflowY: "auto",
                      }}
                    >
                      {teamMembers.slice(0, quantity).map((m) => (
                        <div
                          key={m._id || m.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            background: "#fff",
                            border: "1px solid #e5e7eb",
                            borderRadius: "10px",
                            padding: "10px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
                          }}
                        >
                          <div
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              backgroundColor: "#2563eb",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              fontWeight: "600",
                            }}
                          >
                            {(m.name || m.email || "U")
                              .charAt(0)
                              .toUpperCase()}
                          </div>
                          <div>
                            <div
                              style={{
                                fontWeight: "500",
                                fontSize: "0.9rem",
                              }}
                            >
                              {m.name || "Unknown"}
                            </div>
                            <div
                              style={{
                                fontSize: "0.8rem",
                                color: "#6b7280",
                              }}
                            >
                              {m.email}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <p>Loading plan details...</p>
            )}
          </div>

          {/* Right Card */}
          <div
            style={{
              backgroundColor: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              position: "sticky",
              top: "120px"
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "20px",
                color: "#1e293b",
                paddingBottom: "12px",
                borderBottom: "1px solid #e2e8f0"
              }}
            >
              Order Summary
            </h2>

            {selectedPlan && (
              <div
                style={{
                  fontSize: "0.95rem",
                  color: "#374151",
                  marginBottom: "12px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  ${selectedPlan.pricePerUser} × {quantity}
                </span>
                <strong style={{ color: "#111827" }}>
                  = ${calculateTotalBill()}
                </strong>
              </div>
            )}

            <div
              style={{
                fontSize: "1.1rem",
                fontWeight: "700",
                color: "#111827",
                textAlign: "right",
                marginBottom: "20px",
              }}
            >
              Total: ${calculateTotalBill()}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                margin: "0 -24px -24px -24px",
                padding: "20px 24px 24px 24px",
                borderTop: "1px solid #f1f5f9"
              }}
            >
              <button
                onClick={handleProceedToCheckout}
                style={{
                  width: "100%",
                  padding: "14px 20px",
                  backgroundColor: "#2563eb",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "15px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxSizing: "border-box"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#1d4ed8";
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#2563eb";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Proceed to Checkout
              </button>

              <button
                onClick={handleCancel}
                style={{
                  width: "100%",
                  padding: "14px 20px",
                  backgroundColor: "white",
                  color: "#6b7280",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "15px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxSizing: "border-box"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#f9fafb";
                  e.target.style.borderColor = "#9ca3af";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.borderColor = "#d1d5db";
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Loading Overlay */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            Loading...
          </div>
        </div>
      )}

      {/* Error Toast */}
      {error && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            backgroundColor: "#fee2e2",
            border: "1px solid #fca5a5",
            color: "#991b1b",
            padding: "14px 18px",
            borderRadius: "10px",
            fontWeight: "500",
            zIndex: 1000,
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default Billing;